export default "__VITE_ASSET__CLENghXw__"